import React, { useEffect, useRef, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Controls from "../../../../components/form/controls/Controls";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { getTTSSlotDetail } from "../../../../apis/TTS/slot.api";

const formatJson = (props) => {
  const propsJson = JSON.parse(props.length ? props : "[]");
  const updatedProps = propsJson.map((prop) => ({
    ...prop,
    value: prop.value ? prop.value : "",
  }));

  return updatedProps;
};

const extractFields = (propValue, propAvailable) => {
  // Create a hash map for quick lookup
  const propValueMap = propValue.reduce((map, item) => {
    map[item.name] = item.value;
    return map;
  }, {});

  // Construct the propOutput array
  const propOutput = propAvailable.map((item) => ({
    name: item.name,
    value: propValueMap[item.name] || "", // Assign value if exists, otherwise empty string
  }));
  return propOutput;
};

const IntentValueInputObject = ({
  slot,
  handlePropsChange,
  isReRenderProp,
  recordForEdit,
}) => {
  let { props, id } = slot;

  const [propList, setPropList] = useState([...formatJson(props)]);
  const [slotDetail, setSlotDetail] = useState(null);

  const prevIsReRenderPropRef = useRef(isReRenderProp);
  const prevPropsRef = useRef(props);

  useEffect(() => {
    if (id) {
      getTTSSlotDetail(id, (result) => {
        setSlotDetail({ ...result });
      });
    }
  }, [id]);

  useEffect(() => {
    const propsJson = JSON.parse(props.length ? props : "[]");
    const propActive = JSON.parse(slotDetail?.props || "[]");

    const prevProps = prevPropsRef.current;
    const prevIsReRenderProp = prevIsReRenderPropRef.current;
    if (isReRenderProp !== prevIsReRenderProp || recordForEdit === null) {
      const updatedProps = propsJson.map((prop) => ({
        ...prop,
        value: "",
      }));
      setPropList([...extractFields(updatedProps, [...propActive])]);
    } else if (props !== prevProps || recordForEdit !== null) {
      // Handle change of props
      const updatedProps = propsJson.map((prop) => ({
        ...prop,
        value: prop.value ? prop.value : "",
      }));
      setPropList([...extractFields(updatedProps, [...propActive])]);
    }

    prevIsReRenderPropRef.current = isReRenderProp;
    prevPropsRef.current = props;
  }, [props, isReRenderProp, slotDetail?.props, recordForEdit]);

  const handlePropChange = (e, index) => {
    const { value } = e.target;
    const list = [...propList];
    list[index]["value"] = value;
    setPropList(list);
    handlePropsChange(slot?.name, list);
  };

  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        {`${slot["name"]} properties`}
      </AccordionSummary>
      <AccordionDetails>
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <h5>prop config</h5>
          </div>
          {propList.map((prop, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Controls.Input
                name="name"
                value={prop.value}
                label={`${prop.name}`}
                type="text"
                onChange={(e) => handlePropChange(e, index)}
              />
            </div>
          ))}
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

export default IntentValueInputObject;
